import React from "react"

export const languages = {
  it: {
    locale: "it",
    applications: "ambito applicativo",
    company: "Azienda",
    city: "Indirizzo",
    products: "prodotti",
    search: "Cerca",
    results: "risultati",
    noResults: "nessun risultato",
    discoverMore: "Scopri di più",
    legalAddress: "Sede Legale",
    shareCapital: "Capitale sociale",
    registrationNumber: "Numero Iscrizione",
    vatCode: "P. iva e Cod. Fisc.",
    fullName: "Nome e cognome",
    phone: "Telefono",
    message: "Messaggio",
    consent: "Si, acconsento",
    consentPolicy:
      "Dopo aver preso visione della presente informativa sulla privacy ai sensi dell'ART.13 D.Lgs. n.196 del 2003, a) Acconsento al trattamento dei dati personali al fine esclusivo di avere informazioni riguardo i servizi relativi al presente sito web.",
    loading: "Caricamento",
    submit: "Invia",
    submitted: "Richiesta inviata",
    blog: "Blog",
    back: "Indietro",
    noArticle: "Nessun articolo trovato",
    where: "Dove siamo",
    contacts: "Contatti",
    insight: "News",
    toc: "Indice dei contenuti",
    keyTakeaways: "Punti principali",
    download: "Scarica",
    careers: "Lavora con noi",
    firstName: "Nome",
    lastName: "Cognome",
    uploadCV: "Carica CV (PDF)",
    sendApplication: "Invia candidatura",
    applicationSubmitted: "Candidatura inviata",
    selectFile: "Seleziona file",
    fileSelected: "File selezionato",
  },
  en: {
    locale: "en",
    applications: "application areas",
    company: "Company",
    city: "Address",
    products: "products",
    search: "Search",
    results: "results",
    noResults: "no results",
    discoverMore: "Discover more",
    legalAddress: "Legal Head Office",
    shareCapital: "Share capital",
    registrationNumber: "Registration Number",
    vatCode: "VAT Code",
    fullName: "Full name",
    phone: "Phone",
    message: "Message",
    consent: "I agree",
    consentPolicy:
      "Having read the present Privacy Policy pursuant to ART.13 D.Lgs. n.196 of 2003, a) I hereby give my consent to the processing of my personal data for the exclusive purpose of receiving information related to the services provided by this website.",
    loading: "Loading",
    submit: "Submit",
    submitted: "Submitted",
    blog: "Blog",
    back: "Back",
    noArticle: "No articles found",
    where: "Where we are",
    contacts: "Contacts",
    insight: "News",
    toc: "Table of contents",
    download: "Download",
    keyTakeaways: "Key takeaways",
    careers: "Careers",
    firstName: "First name",
    lastName: "Last name",
    uploadCV: "Upload CV (PDF)",
    sendApplication: "Send application",
    applicationSubmitted: "Application submitted",
    selectFile: "Select file",
    fileSelected: "File selected",
  },
  de: {
    locale: "de",
    applications: "anwendungsbereiche",
    company: "Unternehmen",
    city: "Adresse",
    products: "produkte",
    search: "Suche",
    results: "Ergebnisse",
    noResults: "keine Ergebnisse",
    discoverMore: "Mehr entdecken",
    legalAddress: "Legal Head Office",
    shareCapital: "Share capital",
    registrationNumber: "Registration Number",
    vatCode: "Mehrwertsteuer-Code",
    fullName: "vollständiger Name",
    phone: "Telefon",
    message: "Nachricht",
    consent: "I agree",
    consentPolicy:
      "Having read the present Privacy Policy pursuant to ART.13 D.Lgs. n.196 of 2003, a) I hereby give my consent to the processing of my personal data for the exclusive purpose of receiving information related to the services provided by this website.",
    loading: "Laden",
    submit: "Einreichen",
    submitted: "Eingereicht",
    blog: "Blog",
    back: "Zurück",
    noArticle: "No articles found",
    where: "Wo wir sind",
    contacts: "Kontakte",
    insight: "Nachrichten",
    toc: "Inhalt",
    keyTakeaways: "Wichtige Punkte",
    download: "Herunterladen",
    careers: "Karriere",
    firstName: "Vorname",
    lastName: "Nachname",
    uploadCV: "Lebenslauf hochladen (PDF)",
    sendApplication: "Bewerbung senden",
    applicationSubmitted: "Bewerbung eingereicht",
    selectFile: "Datei auswählen",
    fileSelected: "Datei ausgewählt",
  },
}

export const LanguageContext = React.createContext(languages.it)
